export const SUPPLIER_ORDER_ACTIVE_STATUS_VALUES = [
  'DRAFT',
  'SENT',
  'CONFIRMED',
  'IN_PRODUCTION',
  'READY',
  'SHIPPED',
  'PARTIALLY_RECEIVED',
  'RECEIVED',
  // WP3: finished by the approved purchase invoice ("Zakończone"); set by the
  // backend only, never offered as a manual pick.
  'INVOICED',
  'ON_HOLD',
  'CANCELLED',
] as const;

export const SUPPLIER_ORDER_STATUS_VALUES = SUPPLIER_ORDER_ACTIVE_STATUS_VALUES;

export type ActiveSupplierOrderStatus = typeof SUPPLIER_ORDER_ACTIVE_STATUS_VALUES[number];
export type SupplierOrderStatus = typeof SUPPLIER_ORDER_STATUS_VALUES[number];
